// Only explicitly tagged Mackerel calendar summaries are authoritative here.
import { MACKEREL_RANKING_POLICY, normalizeModeledPeriod } from "./seaBassPresentation";

export const normalizeMackerelDaySelection = (day, normalizeScore, normalizeConfidence) => {
  const basis = ["regional_availability", "availability_based_outlook"].includes(day.ranking_basis)
    ? day.ranking_basis : null;
  const sourcePoints = new Map((Array.isArray(day.timeline) ? day.timeline : [])
    .map(point => [Date.parse(point.timestamp), point]));
  const period = (value) => {
    const normalized = normalizeModeledPeriod(value, normalizeScore, normalizeConfidence);
    if (!basis || !normalized || !Number.isFinite(normalized.meanOpportunity.rawScore)) return null;
    const times = normalized.pointTimestamps.map(Date.parse);
    const count = normalized.kind === "period" ? 3 : 1;
    if (times.length !== count || new Set(times).size !== count || times.some((stamp, i) =>
      !sourcePoints.has(stamp) || !normalizeScore(sourcePoints.get(stamp)?.fishing_opportunity) ||
      sourcePoints.get(stamp)?.eligibility?.biological === "blocked" ||
      (i > 0 && stamp - times[i - 1] !== 3600000)) ||
      Date.parse(normalized.startTimestamp) !== times[0] ||
      Date.parse(normalized.endTimestamp) !== times[count - 1] + (count === 3 ? 3600000 : 0) ||
      !times.includes(Date.parse(normalized.peakTimestamp))) return null;
    return normalized;
  };
  const selected = period(day.modeled_period);
  const candidate = selected ? period(day.alternative_period) : null;
  const alternative = candidate && candidate.kind === selected.kind &&
    !candidate.pointTimestamps.some(stamp => selected.pointTimestamps.some(selectedStamp => Date.parse(stamp) === Date.parse(selectedStamp))) &&
    (Date.parse(candidate.endTimestamp) <= Date.parse(selected.startTimestamp) ||
      Date.parse(candidate.startTimestamp) >= Date.parse(selected.endTimestamp)) ? candidate : null;
  const comparison = ["exact_tie", "similar", "higher", "single_period"].includes(day.day_comparison)
    ? day.day_comparison : "single_period";
  return {
    rankingPolicy: MACKEREL_RANKING_POLICY, rankingBasis: basis,
    modeledPeriod: selected, alternativePeriod: alternative, dayComparison: comparison,
    isBestModeledPeriod: Boolean(selected) && comparison === "higher" && day.is_best_modeled_period === true,
  };
};
